/* Flux PDP default product content: derives layout only from product.description. */
(function (global) {
  'use strict';

  var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  var FEATURE_LABEL = /^(?:features|key features|product features)\s*[:：]?$/i;
  var LABEL_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,div,strong,b,span';
  var REMOVED_ELEMENTS = 'script,iframe,object,embed,style,link,meta,base,template,form,input,button,textarea,select';
  var URL_ATTRIBUTES = ['href', 'src', 'poster', 'cite', 'background'];
  var MEDIA_OR_STRUCTURED = 'img,picture,video,audio,source,track,table,pre,code,a,details';

  function textOf(element) {
    var copy = element.cloneNode(true);
    copy.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(copy.ownerDocument.createTextNode(' '));
    });
    copy.querySelectorAll('p,div,h1,h2,h3,h4,h5,h6,blockquote').forEach(function (block) {
      block.before(copy.ownerDocument.createTextNode(' '));
      block.after(copy.ownerDocument.createTextNode(' '));
    });
    return copy.textContent.replace(/\s+/g, ' ').trim();
  }

  function safeUrl(value, attribute, tagName) {
    var normalized = String(value).replace(/[\u0000-\u0020\u007f-\u009f]/g, '');
    var scheme = normalized.match(/^([a-z][a-z0-9+.-]*):/i);
    if (!scheme) return true;
    if (/^https?$/i.test(scheme[1])) return true;
    if (attribute === 'href' && /^(mailto|tel)$/i.test(scheme[1])) return true;
    if (attribute === 'src' && tagName === 'IMG' && /^data:image\/(?:png|jpe?g|gif|webp|avif|bmp);base64,/i.test(normalized)) return true;
    return false;
  }

  function sanitize(root) {
    root.querySelectorAll(REMOVED_ELEMENTS).forEach(function (element) { element.remove(); });
    root.querySelectorAll('*').forEach(function (element) {
      if (element.namespaceURI !== HTML_NAMESPACE) {
        element.remove();
        return;
      }
      Array.from(element.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase();
        if (/^on/i.test(name) || name === 'srcdoc' || name === 'is' || name === 'formaction' || name === 'action' || name === 'xlink:href') {
          element.removeAttribute(attribute.name);
        } else if (URL_ATTRIBUTES.indexOf(name) !== -1 && !safeUrl(attribute.value, name, element.tagName)) {
          element.removeAttribute(attribute.name);
        } else if (name === 'srcset') {
          // Regular responsive URLs are preserved. Data URLs belong in src only:
          // their embedded commas cannot be safely treated as candidate separators.
          var candidates = attribute.value.split(',');
          if (/data:/i.test(attribute.value) || candidates.some(function (candidate) {
            return !safeUrl(candidate.trim().split(/\s+/)[0], 'src', element.tagName);
          })) element.removeAttribute(attribute.name);
        } else if (name === 'style') {
          // Keep benign source formatting, while rejecting executable CSS and URL
          // declarations (which can contain escaped schemes and external loads).
          if (/(?:url\s*\(|expression\s*\(|@import|behavior\s*:|-moz-binding|\\)/i.test(attribute.value)) element.removeAttribute(attribute.name);
        }
      });
      if (element.tagName === 'A' && element.getAttribute('target') === '_blank') {
        var rel = (element.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        element.setAttribute('rel', rel.join(' '));
      }
    });
  }

  function removeEmptyBlocks(root) {
    root.querySelectorAll('p,h1,h2,h3,h4,h5,h6').forEach(function (element) {
      // An ID, media, anchor, inline element, or other child may be meaningful.
      if (element.attributes.length || element.textContent.trim()) return;
      if (Array.from(element.childNodes).every(function (node) {
        return (node.nodeType === 3 && !node.textContent.trim()) || (node.nodeType === 1 && node.tagName === 'BR');
      })) element.remove();
    });
  }

  function splitPlainParagraphs(root) {
    root.querySelectorAll('p').forEach(function (paragraph) {
      if (!Array.from(paragraph.childNodes).every(function (node) { return node.nodeType === 3; })) return;
      var parts = paragraph.textContent.replace(/\r\n?/g, '\n').split(/\n(?:[ \t]*\n)+/);
      if (parts.length < 2) return;
      var fragment = paragraph.ownerDocument.createDocumentFragment();
      var nonEmpty = parts.filter(function (part) { return part.trim(); });
      nonEmpty.forEach(function (part, index) {
        var next = paragraph.cloneNode(false);
        if (index > 0) next.removeAttribute('id');
        next.textContent = part.trim();
        fragment.appendChild(next);
      });
      if (nonEmpty.length) paragraph.replaceWith(fragment);
    });
  }

  function findFeatureHeading(list) {
    // A nested list is part of its parent's item, never a separate section.
    if (list.parentElement && list.parentElement.closest('ul,ol,li')) return null;
    var node = list.previousSibling;
    while (node && ((node.nodeType === 3 && !node.textContent.trim()) || node.nodeType === 8)) node = node.previousSibling;
    if (!node || node.nodeType !== 1 || !node.matches(LABEL_SELECTOR)) return null;
    if (!FEATURE_LABEL.test(textOf(node))) return null;
    if (node.querySelector('ul,ol,img,picture,video,audio,table,iframe,hr,a')) return null;
    return node;
  }

  function extractFeatures(root) {
    var features = [];
    root.querySelectorAll('ul').forEach(function (list) {
      if (!root.contains(list)) return;
      var heading = findFeatureHeading(list);
      if (!heading || list.querySelector(MEDIA_OR_STRUCTURED)) return;
      // Complex lists retain their original hierarchy and markup in the details.
      // Only text-based, flat lists can be moved without losing information.
      if (list.querySelector('ul,ol') || Array.from(list.children).some(function (child) { return child.tagName !== 'LI'; })) return;
      if (Array.from(list.childNodes).some(function (node) { return node.nodeType === 3 && node.textContent.trim(); })) return;
      var items = Array.from(list.children).map(textOf);
      if (!items.length || items.some(function (item) { return !item; })) return;
      features = features.concat(items);
      heading.remove();
      list.remove();
    });
    return features;
  }

  function parse(html) {
    var template = global.document.createElement('template');
    template.innerHTML = typeof html === 'string' ? html : '';
    var root = template.content;
    sanitize(root);
    removeEmptyBlocks(root);
    var features = extractFeatures(root);
    splitPlainParagraphs(root);
    removeEmptyBlocks(root);
    return { features: features, detailHtml: template.innerHTML.trim() };
  }

  global.FluxPDPContent = { parse: parse };
})(window);
